import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {UserEmailVerificationPanelProps} from '@Panels/user-email-verification-panel/user-email-verification-panel.types';

export const openUserEmailVerificationModal = (props: UserEmailVerificationPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.USER_EMAIL_VERIFICATION_MODAL,
      isDismissible: props.isDismissable ?? true,
      panelProps: {
        ...props,
      },
    })
  );
};
